"use client";
import React from "react";
import "./CardComponent.css";
const FlipCard = ({ title, description }) => {
  return (
    <div className="card-container">
      <div className="card">
        <div className="card-front">
          <h2>{title}</h2>
        </div>
        <div className="card-back">
          <p>{description}</p>
        </div>
      </div>
    </div>
  );
};
export default FlipCard;
